var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ajuda"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M6.05999 6.00002C6.21672 5.55446 6.52609 5.17875 6.93329 4.93944C7.34049 4.70012 7.81925 4.61264 8.28477 4.69249C8.75029 4.77234 9.17253 5.01436 9.47671 5.3757C9.78088 5.73704 9.94736 6.19436 9.94666 6.66668C9.94666 8.00002 7.94666 8.66669 7.94666 8.66669M7.99999 11.3334H8.00666M14.6667 8.00002C14.6667 11.6819 11.6819 14.6667 7.99999 14.6667C4.31809 14.6667 1.33331 11.6819 1.33331 8.00002C1.33331 4.31812 4.31809 1.33334 7.99999 1.33334C11.6819 1.33334 14.6667 4.31812 14.6667 8.00002Z",
    stroke: "#0466C8",
    strokeWidth: 1.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.5dba3023020d11b83aaffb6c31d44cd5.svg";
export { ForwardRef as ReactComponent };